export default [
 {
    path: "/exam/s-plan",
    name: "SplanOverview",
    component: () => import("@/views/exam/s-plan/index_v2.vue"),
    meta: { title: "S-PLAN 검사" },
  },
  { path: "/exam/s-plan/overview", redirect: "/exam/s-plan" },
  { path: "/exam/s-plan/implementation", redirect: "/exam/s-plan" },
  { path: "/exam/s-plan/method", redirect: "/exam/s-plan" },
  { path: "/exam/s-plan/result", redirect: "/exam/s-plan" }, 

  /*v1 - 기존
    {
    path: "/exam/s-plan",
    component: () => import("@/views/exam/s-plan/index.vue"),
    meta: { title: "S-PLAN 검사" },
    children: [
    {
      path: "overview",
      name: "SplanOverview",
      component: () => import("@/views/exam/s-plan/Overview.vue"),
      meta: { title: "S-PLAN 검사 개요" },
    },
    {
      path: "implementation",
      name: "SplanImplementation",
      component: () => import("@/views/exam/s-plan/Implementation.vue"),
      meta: { title: "S-PLAN 시행 안내" },
    },
    {
      path: "method",
      name: "SplanMethod",
      component: () => import("@/views/exam/s-plan/Method.vue"),
      meta: { title: "S-PLAN 검사 방법" },
    },
    {
      path: "result",
      name: "SplanResult",
      component: () => import("@/views/exam/s-plan/Result.vue"),
      meta: { title: "S-PLAN 검사 결과" },
    },
  ],
}, */

  {
    path: "/exam/ai-literacy",
    name: "AiOverview",
    component: () => import("@/views/exam/ai-literacy/index_v2.vue"),
    meta: { title: "AI·디지털 리터러시 검사" },
  },
  { path: "/exam/ai-literacy/overview", redirect: "/exam/ai-literacy" },
  { path: "/exam/ai-literacy/implementation", redirect: "/exam/ai-literacy" },
  { path: "/exam/ai-literacy/method", redirect: "/exam/ai-literacy" },
  { path: "/exam/ai-literacy/result", redirect: "/exam/ai-literacy" },

  /* v1 - AI 리터러시 기존
  {
    path: "/exam/ai-literacy",
    component: () => import("@/views/exam/ai-literacy/index.vue"),
    meta: { title: "AI·디지털 리터러시 검사" },
    children: [
      {
        path: "overview",
        name: "AiOverview",
        component: () => import("@/views/exam/ai-literacy/Overview.vue"),
        meta: { title: "AI·디지털 리터러시 검사 개요" },
      },
      {
        path: "implementation",
        name: "AiImplementation",
        component: () => import("@/views/exam/ai-literacy/Implementation.vue"),
        meta: { title: "AI·디지털 리터러시 시행 안내" },
      },
      {
        path: "method",
        name: "AiMethod",
        component: () => import("@/views/exam/ai-literacy/Method.vue"),
        meta: { title: "AI·디지털 리터러시 검사 방법" },
      },
      {
        path: "result",
        name: "AiResult",
        component: () => import("@/views/exam/ai-literacy/Result.vue"),
        meta: { title: "AI·디지털 리터러시 검사 결과" },
      },
    ],
  }, */
  {
    path: "/exam/essay",
    name: "EssayOverview",
    component: () => import("@/views/exam/essay/Overview.vue"),
    meta: { title: "서·논술형 AI 평가" },
  },
  { path: "/exam/essay/overview", redirect: "/exam/essay" },
  { path: "/exam/essay/implementation", redirect: "/exam/essay" },
  { path: "/exam/essay/method", redirect: "/exam/essay" },
  { path: "/exam/essay/result", redirect: "/exam/essay" },
];
